import { Schema } from "effect";
import {
  AccountId,
  ConversationId,
  ConversationThreadId,
  MessageId,
} from "../../../ids/definitions";
import { MessageChannelData } from "./message/channel-data";

export const MessageChannel = Schema.Literal(
  "email",
  "redoChat",
  "facebook",
  "facebookComments",
  "instagram",
  "instagramComments",
  "sms",
  "voice",
  "attentive",
  "postscript",
  "tiktok",
  "contactForm",
);
export type MessageChannel = typeof MessageChannel.Type;

export const MessageOrigin = Schema.Literal("external", "internal");
export type MessageOrigin = typeof MessageOrigin.Type;

export const MessageProcessingStatus = Schema.Literal(
  "pending",
  "processing",
  "processed",
  "failed",
);
export type MessageProcessingStatus = typeof MessageProcessingStatus.Type;

export const MessageResponse = Schema.Struct({
  id: MessageId,
  conversationThreadId: ConversationThreadId,
  accountId: AccountId,
  content: Schema.optional(Schema.String),
  channel: MessageChannel,
  origin: MessageOrigin,
  sentAt: Schema.Date,
  channelData: Schema.NullOr(MessageChannelData),
});

export type MessageResponse = typeof MessageResponse.Type;

export const MessageCursor = Schema.Struct({
  sentAt: Schema.DateFromString,
  id: MessageId,
});
export type MessageCursor = typeof MessageCursor.Type;

export type MessageWithConversationId = MessageResponse & {
  conversationId?: ConversationId;
};
